import { RiStarFill } from '@remixicon/react';
import { useSidebar } from 'src/providers/SidebarContextProvider';
import SidebarLink from './SidebarLink';

export default function RouteFavorites() {
  const { favorites } = useSidebar();
  return (
    favorites.length > 0 && (
      <div className="col pb-4">
        {favorites.map(({ route, label }) => (
          <SidebarLink key={label} text={label} icon={RiStarFill} to={route} />
        ))}
      </div>
    )
  );
}
